export function buildInvestigationBundle ({ clientId, config, viewName, asOfDate, row, rowPath, orionRequest }) {
  const columns = (config?.columns || []).map(c => ({
    id: c.id,
    label: c.displayName || c.label || c.id
  }))

  const values = extractRowValues(row, columns)

  const subject = {
    source: 'portfolio-explorer',
    clientId,
    asOfDate,
    rowName: row?.name ?? null,
    view: viewName ?? config?.name ?? null
  }

  const bundle = {
    source: 'portfolio-explorer',
    clientId,
    view: {
      name: viewName ?? config?.name ?? null,
      asOfDate,
      groupings: Array.isArray(config?.groupings) ? config.groupings : [],
      columns
    },
    selected: {
      row: {
        name: row?.name ?? null,
        depth: row?.depth ?? 0,
        ...(row?.grouping ? { grouping: row.grouping } : {}),
        ...(row?.groupEntityId != null ? { groupEntityId: row.groupEntityId } : {}),
        values
      },
      rowPath: Array.isArray(rowPath) ? rowPath : [row?.name].filter(Boolean)
    },
    orion: {
      request: orionRequest
    }
  }

  return { bundle, subject }
}

function extractRowValues (row, columns) {
  const values = {}
  if (!row || !columns) return values
  for (const col of columns) {
    const v = row[col.id]
    if (v === null || v === undefined) continue
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      values[col.id] = v
    }
  }
  return values
}
